<div class="of-container">
  <div class="of-header">
    <h2>Ordres de Fabrication</h2>
    <div class="header-buttons">
      <button mat-raised-button color="primary" (click)="refreshList()">
        <mat-icon>refresh</mat-icon>
        Rafraîchir
      </button>
      <button mat-raised-button color="accent">
        <mat-icon>schedule</mat-icon>
        Jalonner
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="!isLoading && ordersFabrication.length === 0" class="empty-state">
    <mat-icon>inbox</mat-icon>
    <p>Aucun ordre de fabrication disponible</p>
  </div>

  <div 
    *ngIf="!isLoading && ordersFabrication.length > 0" 
    cdkDropList
    #ofList="cdkDropList"
    [cdkDropListData]="ordersFabrication"
    cdkDropListSortingDisabled
    (cdkDropListDropped)="drop($event)"
    class="of-list"
  >
    <mat-accordion class="of-accordion">
      <mat-expansion-panel 
        *ngFor="let of of ordersFabrication; let i = index"
        cdkDrag
        [cdkDragData]="of"
        class="of-panel"
      >
        <mat-expansion-panel-header 
          class="panel-header"
          [ngClass]="{'header-pe1': of.OpeLignes?.[0]?.Poste === 'PE1', 'header-pe2': of.OpeLignes?.[0]?.Poste === 'PE2', 'header-default': of.OpeLignes?.[0]?.Poste !== 'PE1' && of.OpeLignes?.[0]?.Poste !== 'PE2'}"
        >
          <mat-panel-title class="header-title">
            <span class="drag-handle" cdkDragHandle>⋮⋮</span>
            <span class="of-info">{{ getHeaderLabel(of) }}</span>
            <span class="of-dates">{{ of.DateDebutTot | date:'dd/MM/yyyy' }} - {{ of.DateFinTard | date:'dd/MM/yyyy' }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="panel-content">
          <!-- Formulaire détails -->
          <div class="details-section">
            <h3>Détails</h3>
            <mat-divider></mat-divider>
            <form class="details-form">
              <div class="form-row">
                <mat-form-field>
                  <mat-label>Date début</mat-label>
                  <input 
                    matInput 
                    type="date" 
                    [value]="of.DateDebutTot | date:'yyyy-MM-dd'"
                    disabled
                  />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Date fin</mat-label>
                  <input 
                    matInput 
                    type="date" 
                    [value]="of.DateFinTard | date:'yyyy-MM-dd'"
                    disabled
                  />
                </mat-form-field>
              </div>

              <div class="form-row">
                <mat-form-field>
                  <mat-label>Article</mat-label>
                  <input 
                    matInput 
                    [value]="of.Article"
                    disabled
                  />
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Description</mat-label>
                  <input 
                    matInput 
                    [value]="of.DescArticle"
                    disabled
                  />
                </mat-form-field>
              </div>
            </form>
          </div>

          <!-- Tableau des opérations -->
          <div class="operations-section">
            <h3>Opérations</h3>
            <mat-divider></mat-divider>
            <div class="table-wrapper">
              <table mat-table [dataSource]="getOperations(of)" class="operations-table">
                <!-- Column Num Op -->
                <ng-container matColumnDef="NumOperProd">
                  <th mat-header-cell *matHeaderCellDef>Num Op</th>
                  <td mat-cell *matCellDef="let element">{{ element.NumOperProd }}</td>
                </ng-container>

                <!-- Column Description -->
                <ng-container matColumnDef="Description">
                  <th mat-header-cell *matHeaderCellDef>Description</th>
                  <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
                </ng-container>

                <!-- Column Quantité -->
                <ng-container matColumnDef="QteLancee">
                  <th mat-header-cell *matHeaderCellDef>Quantité</th>
                  <td mat-cell *matCellDef="let element">{{ element.QteLancee }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>

            <div *ngIf="getOperations(of).length === 0" class="no-operations">
              <p>Aucune opération</p>
            </div>
          </div>

          <!-- Boutons d'action -->
          <div class="action-buttons">
            <button mat-raised-button color="primary">
              <mat-icon>edit</mat-icon>
              Éditer
            </button>
            <button mat-raised-button color="warn">
              <mat-icon>delete</mat-icon>
              Supprimer
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
